<template>
  <div class="t-calendar-body__day-week" :class="{'t-calendar_small__day-week': mobileCalendar}" v-if="type === 1">
    <span v-for="(day, index_day) in dayWeek" :key="'day_week_' + index_day">{{ day }}</span>
  </div>
  <div class="t-calendar-body__day-week t-calendar-body__day-week_small" v-else>
    <span></span>
    <span v-for="(day, index_day) in day_week_header" :key="'day_week_header_' + index_day">{{ day.label }}</span>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
      props: ['type'],
      // watch: {
      //   type(){
      //     console.log(this.type.value.value);
          
      //   }
      // },
      computed: {
          ...mapGetters('calendar', ['day_week', 'day_week_small', 'day_week_header']),
          ...mapGetters(['mobileCalendar']),
          dayWeek(){
              return this.mobileCalendar ? this.day_week_small : this.day_week;
          }
      }
    }
</script>

<style lang="sass">
.t-calendar-body__day-week
  display: flex
  align-items: center
  width: 100%
  background: #fff
  position: sticky
  top: 130px
  z-index: 13
  @media (max-width: 769px)
    top: 30px
  span
    flex: none
    width: calc(100% / 7)
    padding: 8px
    font-size: 14px
    color: $blue
  &_small
    span
      width: calc((100% - 88px) / 7)
      &:first-child
        width: 88px
        flex: none
  &.t-calendar_small__day-week
    justify-content: space-between
    height: 32px
    margin-bottom: 8px
    position: sticky
    top: 25px
    background: #fff
    z-index: 15
    span
      width: 36px
      text-align: center
      padding: 0
      color: $black
      font-size: 16px
</style>


// WEBPACK FOOTER //
// src/vue_components/Calendar/CalendarBodyHeader.vue